import { AppLanguage } from '../../_models';
import { LanguageCode, LanguageCodeUI, LanguageKey } from '../_enums';

export const appDefaultLang = LanguageCode.en;
export const appLanguages: AppLanguage[] = [
  {
    name: 'English',
    key: LanguageKey.en,
    code: LanguageCode.en,
    codeUI: LanguageCodeUI.en,
  },
  {
    name: 'Tiếng Việt',
    key: LanguageKey.vi,
    code: LanguageCode.vi,
    codeUI: LanguageCodeUI.vi,
  },
];
